import styled from 'styled-components';
import { darken } from 'polished';

export const LinkContainer = styled.span`
  input {
    cursor: pointer;
    color: #5454d6;

    &:hover {
      color: ${darken(0.1, '#5454d6')};
    }
  }
`;
